import React from 'react';

type Props = Partial<Cart>;

export const ProductList = ({items = []}: Props) => {
  return (
    <ul>
      {items.map(item => (
        <li key={item.id}>
          <span>{item.title}</span>
        </li>
      ))}
    </ul>
  );
};
